<div class="header flex justify-content-between align-items-center surface-700">
  <div class="flex align-items-center gap-2 pl-2">
    <!-- <p-button
      *ngIf="isMobile$ | async"
      icon="pi pi-bars"
      styleClass="p-button-rounded p-button-light p-button-text"
      [style]="{ height: '35px', width: '35px' }"
      (onClick)="showSideMenu.emit(true)"
    ></p-button> -->
    <img
      class="logo"
      src="./assets/icons/logo_top.png"
      (click)="onLogoClick()"
    />
    <div>
      <h3 class="text-white">
        <ng-container *ngIf="innerWidth != 0 && innerWidth > 1180">
          {{ environment.appTitle }}
          <div>
            <small class="font-light">
              {{ environment.appSubtitle }}
            </small>
          </div>
        </ng-container>
        <ng-container *ngIf="innerWidth != 0 && innerWidth <= 1180">
          {{ environment.appTitleShort }}
        </ng-container>
      </h3>
      <small *ngIf="isStageEnvironment && innerWidth <= 600">
        ΔΟΚΙΜΑΣΤΙΚΟ ΠΕΡΙΒΑΛΛΟΝ
      </small>
    </div>
  </div>
  <div class="flex align-items-center mr-2">
    <!--<h4 class="staging-header" *ngIf="isStageEnvironment">ΔΟΚΙΜΑΣΤΙΚΟ ΠΕΡΙΒΑΛΛΟΝ</h4>-->
    <div
      class="flex justify-content-center gap-2"
      style="min-width: 280px"
      *ngIf="isStageEnvironment && innerWidth > 600"
    >
      <p-message severity="info" text="ΔΟΚΙΜΑΣΤΙΚΟ ΠΕΡΙΒΑΛΛΟΝ"></p-message>
    </div>
    <p-splitButton
      icon="pi pi-user"
      styleClass="p-button-info"
      [label]="innerWidth > 800 ? getNameAndRole() : ''"
      [model]="userMenuItems"
      text
      (onClick)="onUserButtonClick()"
    >
    </p-splitButton>
  </div>
</div>
<!-- <hr class="shadow-1" /> -->
